import React from 'react';
import { Plus, Save } from 'lucide-react';
import { ALGORITHMS, PLATFORMS } from '../utils/constants';

const AddProblemForm = ({ formData, setFormData, onSubmit, onCancel }) => {
  return (
    <div className="form-container">
      <h2 className="form-title">
        <Plus size={24} />
        Add New Problem
      </h2>
      <div className="form-content">
        <div className="form-row">
          <input
            type="text"
            placeholder="Problem Title *"
            className="form-input"
            value={formData.title}
            onChange={(e) => setFormData({ ...formData, title: e.target.value })}
          />
          <select
            className="form-select"
            value={formData.platform}
            onChange={(e) => setFormData({ ...formData, platform: e.target.value })}
          >
            {PLATFORMS.map((platform) => (
              <option key={platform} value={platform}>
                {platform}
              </option>
            ))}
          </select>
        </div>

        <input
          type="url"
          placeholder="Problem URL"
          className="form-input"
          value={formData.problemUrl}
          onChange={(e) => setFormData({ ...formData, problemUrl: e.target.value })}
        />

        <div className="form-row">
          <select
            className="form-select"
            value={formData.difficulty}
            onChange={(e) => setFormData({ ...formData, difficulty: e.target.value })}
          >
            <option>Easy</option>
            <option>Medium</option>
            <option>Hard</option>
          </select>
          <select
            className="form-select"
            value={formData.algorithm}
            onChange={(e) => setFormData({ ...formData, algorithm: e.target.value })}
          >
            <option value="">Select Algorithm *</option>
            {ALGORITHMS.map((algo) => (
              <option key={algo} value={algo}>
                {algo}
              </option>
            ))}
          </select>
          <input
            type="text"
            placeholder="Time Taken (e.g., 25 mins)"
            className="form-input"
            value={formData.timeTaken}
            onChange={(e) => setFormData({ ...formData, timeTaken: e.target.value })}
          />
        </div>

        <div className="form-row">
          <input
            type="text"
            placeholder="Time Complexity (e.g., O(n log n))"
            className="form-input"
            value={formData.timeComplexity}
            onChange={(e) => setFormData({ ...formData, timeComplexity: e.target.value })}
          />
          <input
            type="text"
            placeholder="Space Complexity (e.g., O(n))"
            className="form-input"
            value={formData.spaceComplexity}
            onChange={(e) => setFormData({ ...formData, spaceComplexity: e.target.value })}
          />
        </div>

        <textarea
          placeholder="Your Solution (code/approach) *"
          className="form-textarea"
          value={formData.solution}
          onChange={(e) => setFormData({ ...formData, solution: e.target.value })}
        />

        <textarea
          placeholder="Additional Notes & Key Insights"
          className="form-textarea form-textarea-notes"
          value={formData.notes}
          onChange={(e) => setFormData({ ...formData, notes: e.target.value })}
        />

        <div className="form-actions">
          <button onClick={onSubmit} className="btn btn-primary">
            <Save size={20} />
            Add Problem
          </button>
          <button onClick={onCancel} className="btn btn-secondary">
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddProblemForm;